import{a as e}from"./chunk-6DC7D3TO.js";import{a as m}from"./chunk-LWM7TK5F.js";import{n as r,o}from"./chunk-3QROWZCZ.js";var i=new r({locale:[e,m,o]});export{i as a};
